import request from '@/utils/request'
// 获取报价列表
export function setNewCaseListByApi(para){
    return request({
        url:'/vehicle/caseonline/setApiNewVehicleList/',
        method:'post',
        data:para,
    })
}

//获取中标结果
export function getBidResult(para){
    return request({
        url:'/vehicle/caseonline/getApiBidResult/',
        method:'post',
        data:para,
    })
}
